<template>
  <div class="rj-tabs">
    <div class="rj-tabs-wrapper">
      <div class="rj-tabs-names">
        <div v-for="(pane,index) in panes" :key="index" class="rj-tab-name" :class="{'active':currentName==pane.name}" @click="chooseTab(pane)">
          <template v-if="pane.slotLabel">
            <tab-name :node="pane.slotLabel" />
          </template>
          <template v-else>
            {{ pane.label }}
          </template>
        </div>
      </div>
      <div class="rj-tab-tip">
        {{ tip }} <slot name="tip" />
      </div>
    </div>
    <div class="rj-tabs-body">
      <slot />
    </div>
  </div>
</template>
<script type="es6">
import tabName from './tabsName';
export default {
  model: {
    prop: 'activeName',
    event: 'change'
  },
  data () {
    return {
      panes: [],
      currentName: ''
    };
  },
  props: {
    activeName: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  provide () {
    return {
      rootTabs: this
    };
  },
  components: {
    tabName
  },
  computed: {
  },
  methods: {
    calcPaneInstances (isForceUpdate = false) {
      if (this.$slots.default) {
        const paneSlots = this.$slots.default.filter(vnode => vnode.tag &&
          vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'TabPane');
        // update indeed
        const panes = paneSlots.map(({ componentInstance }) => {
          if (componentInstance.$slots.label) {
            componentInstance.$set(componentInstance, 'slotLabel', componentInstance.$slots.label[0]);
          }
          return componentInstance;
        });
        const panesChanged = !(panes.length === this.panes.length && panes.every((pane, index) => pane === this.panes[index]));
        if (isForceUpdate || panesChanged) {
          this.panes = panes;
        }
      } else if (this.panes.length !== 0) {
        this.panes = [];
      }
    },
    chooseTab (pane) {
      this.currentName = pane.name;
      this.$emit('change', this.currentName);
    }
  },
  updated () {
    this.calcPaneInstances();
  },
  mounted () {
    this.currentName = this.activeName;
    this.calcPaneInstances();
  }
};
</script>
<style lang="scss">
  @import "../../style/var";
  @include namespace(tabs){
  }
  @include namespace(tabs-names){
    position: relative;
    width: 90%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    &::-webkit-scrollbar{
      height: 5px;
      background: #ddd;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc; /* 设置滑块背景颜色 */
      border-radius: 4px; /* 设置滑块圆角 */
    }
  }
  @include namespace(tabs-wrapper){
    display: flex;
    align-items: center;
  }
  @include namespace(tabs-body){
    background: #fff;
    padding: 20px 10px;
  }
  @include namespace(tab-name){
    display: inline-block;
    flex-shrink: 0;
    padding: 10px 20px;
    text-align: center;
    font-size: 15px;
    color: $--color-text-primary;
    cursor: pointer;
    border-right: $--border-base;
    background: $TabsNamesHeaderBG;
    position: relative;
    &.active{
      background: #fff;
      color: $--color-primary-light-1;
      &::before{
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 2px;
        background: $--color-primary;
        content: "";
      }
    }
    &:nth-last-of-type(2){
      border-right: none;
    }
  }
  @include namespace(tab-tip){
    padding: 6px 15px;
    @include tipText;
  }
</style>
